import { Environment } from "@react-three/drei"
import { useFrame, useThree } from "@react-three/fiber"
import { useActsStore } from "../store/useActsStore"
import { useRef } from "react"
import { movePropertiesRange } from "../utils/moveObjects"
import * as THREE from 'three'
import { backgroundIntensity } from "three/tsl"



export default function EnvMap() {
    const { scene } = useThree()
    const intensityRef = useRef(1)

    useFrame(() => {
        const { getCurrentActId, actsProgress } = useActsStore.getState()
        const id = getCurrentActId()
        if (id == null) return

        const current = actsProgress[id]
        if (!current) return

        const holdProgress = current.holdProgress ?? 0
        const isAct2 = id === 1
        const isAct3 = id === 2

        // 🔹 par défaut : on garde la valeur actuelle
        let target = intensityRef.current

        // ACTE 2 : 1 -> 0 de 0.2 à 0.4
        if (isAct3) {
            const t = THREE.MathUtils.clamp(
                holdProgress / 0.1,
                0,
                1
            )
            target = THREE.MathUtils.lerp(0, 1, t)
        }
        else if (isAct2) {
            const t = THREE.MathUtils.clamp(
                (holdProgress - 0.3) / (0.55 - 0.3),
                0,
                1
            )
            target = THREE.MathUtils.lerp(1, 0, t)
        }

        intensityRef.current = THREE.MathUtils.lerp(
            intensityRef.current,
            target,
            0.1
        )

        scene.backgroundIntensity = intensityRef.current
        
    })

    return (
        <Environment
            files="./envmap/envmapold.hdr"
            background
            environmentRotation={[0, 2, 0]}
            backgroundRotation={[0, 2, 0]}
            environmentIntensity={10}
            backgroundIntensity={1}
            backgroundBlurriness={0.5}
        />
    )
}
